<template>

    <router-view></router-view>

</template>


<script>
export default {
  name: "ProducersModule",
  components: {},
  data: () => ({}),
};
</script>
